import { fetchAPI } from '@quickbit/backoffice-core-frontend';
import type { MoneyScaled } from '@quickbit/qb-design-system';

export type WalletType = 'MAIN' | 'CORPORATE';

export interface WalletMinimal {
  uuid: string;
  address: string | null;
  currencyCode: string;
  walletType: WalletType;
  userId: string;
  disabled: boolean;
}

export interface WalletDetails extends WalletMinimal {
  balance: MoneyScaled;
  userEmail: string | null;
  nexusAccountCode: string | null;
}

export interface SearchWalletsFilters {
  address?: string;
  currency?: string;
}

export interface SearchWalletsResponse {
  wallets: WalletMinimal[];
  aggregatedData: { count: number };
}

export const searchWallets = (args: {
  filters: SearchWalletsFilters;
  pagination?: { page: number; size: number };
}) =>
  fetchAPI<SearchWalletsResponse>('v1/wallets:search', {
    method: 'POST',
    body: args,
  });

export const getWalletDetails = (walletId: string) =>
  fetchAPI<WalletDetails>(`v1/wallets/${walletId}`, { method: 'GET' });
